import axios from 'axios';

const LOAD_PROFILE = 'profile/LOAD_PROFILE';
const LOAD_PROFILE_SUCCESS = 'profile/LOAD_PROFILE_SUCCESS';
const LOAD_PROFILE_FAILED = 'profile/LOAD_PROFILE_FAILED';

const LOAD_PROFILE_REVIEW_NEW = 'profile/LOAD_PROFILE_REVIEW_NEW';
const LOAD_PROFILE_REVIEW_NEW_SUCCESS = 'profile/LOAD_PROFILE_REVIEW_NEW_SUCCESS';
const LOAD_PROFILE_REVIEW_NEW_FAILED = 'profile/LOAD_PROFILE_REVIEW_NEW_FAILED';
const CLEAR_REVIEW_NEW = 'profile/CLEAR_REVIEW_NEW';

const REGISTER_NOTIFY_ME = 'profile/REGISTER_NOTIFY_ME';
const REGISTER_NOTIFY_ME_SUCCESS = 'profile/REGISTER_NOTIFY_ME_SUCCESS';
const REGISTER_NOTIFY_ME_FAILED = 'profile/REGISTER_NOTIFY_ME_FAILED';
const RESET_NOTIFY_ME = 'profiel/RESET_NOTIFY_ME';

const initialState = () => ({
  profile: null,
  loading: false,
  loaded: false,
  error: null,
  sendingNotifiedMe: false,
  sentNotifiedMe: false,
  checkingCanReview: false,
  checkedCanReview: false,
  reference: null,
});

export default function recommended(state = initialState(), action = {}) {
  switch (action.type) {
    case RESET_NOTIFY_ME:
      return {
        ...state,
        sendingNotifiedMe: false,
        sentNotifiedMe: false,
      };
    case REGISTER_NOTIFY_ME:
      return {
        ...state,
        sendingNotifiedMe: true,
        sentNotifiedMe: false,
      };
    case REGISTER_NOTIFY_ME_SUCCESS:
      return {
        ...state,
        sendingNotifiedMe: false,
        sentNotifiedMe: true,
      };
    case REGISTER_NOTIFY_ME_FAILED:
      return {
        ...state,
        sendingNotifiedMe: false,
        sentNotifiedMe: false,
      };
    case CLEAR_REVIEW_NEW:
      return {
        ...state,
        checkingCanReview: false,
        checkedCanReview: false,
        reference: {}
      };
    case LOAD_PROFILE_REVIEW_NEW:
      return {
        ...state,
        checkingCanReview: true,
        checkedCanReview: false,
      };
    case LOAD_PROFILE_REVIEW_NEW_SUCCESS:
      return {
        ...state,
        checkingCanReview: false,
        checkedCanReview: true,
        reference: action.result,
      };
    case LOAD_PROFILE_REVIEW_NEW_FAILED:
      return {
        ...state,
        checkingCanReview: false,
        checkedCanReview: false,
      };
    case LOAD_PROFILE:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case LOAD_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case LOAD_PROFILE_SUCCESS: {
      return {
        ...state,
        profile: action.result,
        loaded: true,
        loading: false,
      };
    }
    default:
      return state;
  }
}

export function loadProfile(id) {
  return {
    types: [LOAD_PROFILE, LOAD_PROFILE_SUCCESS, LOAD_PROFILE_FAILED],
    promise: ({ client }) => client.get('/profile/load', {
      params: {
        id,
      }
    })
  };
}

export function clearReviewNew() {
  return {
    type: CLEAR_REVIEW_NEW,
  };
}

export function checkReviewNew(id, token) {
  return {
    types: [LOAD_PROFILE_REVIEW_NEW, LOAD_PROFILE_REVIEW_NEW_SUCCESS, LOAD_PROFILE_REVIEW_NEW_FAILED],
    promise: ({ client }) => client.post('/profile/checknewreview', {
      data: {
        id,
        token,
      }
    })
  };
}

export function isProfileLoaded(state, slug = '') {
  if (
    state.profile
    && state.profile.loaded
    && state.profile.profile
    && state.profile.profile.slug
  ) {
    return state.profile.profile.slug === slug;
  }

  return false;
}

export function registerNotifyMe({
  email,
  feature = '',
}) {
  return {
    types: [REGISTER_NOTIFY_ME, REGISTER_NOTIFY_ME_SUCCESS, REGISTER_NOTIFY_ME_FAILED],
    promise: () => axios.post('https://us-central1-collect-email-cloud-functions.cloudfunctions.net/register', {
      email,
      feature
    })
  };
}

export function resetNotifyMe() {
  return {
    type: RESET_NOTIFY_ME,
  };
}
